<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="项目"
      class="project-edit"
      width="500px"
      top="3vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="project"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="项目名字">
        <el-input v-model="project.name" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="客户" prop="customerId">
        <el-input v-model="project.customerName" placeholder="请选择" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectCompany.open()"/>
        </el-input>
        <!--<customer-select ref="selectCompany" @select="onSelectCompany"/>-->
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="project.contactName" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="project.phone" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="维保经理" prop="maintManagerId">
        <el-input v-model="project.maintManager" placeholder="请选择" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaintenanceManager.open()"/>
        </el-input>
        <!--<user-select ref="selectMaintenanceManager" @select="onSelectMaintenanceManager"/>-->
      </el-form-item>
      <el-form-item label="业务员" prop="salesmanId">
        <el-input v-model="project.salesman" placeholder="请选择" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectSalesman.open()"/>
        </el-input>
        <!--<user-select ref="selectSalesman" @select="onSelectSalesman"/>-->
      </el-form-item>
      <el-form-item label="区域经理" prop="areaManagerId">
        <el-input v-model="project.areaManager" placeholder="请选择" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectAreaManager.open()"/>
        </el-input>
        <!--<user-select ref="selectAreaManager" @select="onSelectAreaManager"/>-->
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import regular from "@/util/regular";

  export default {
    name:"ProjectEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        project: {
          id: 0,
          phone: "",
          name: "",
          contactName: "",
          customerName: "",
          customerId: "",
          maintManager: "",
          maintManagerId: "",
          salesman: "",
          salesmanId: "",
          areaManager: "",
          areaManagerId: "",
        },
        ruleValidate: {
          phone: {
            required: true,
            pattern: regular.phone,
            trigger: "blur",
            message: "手机号格式不正确",
          },
          // customerId: {required: true,type: "array", message: "请选择客户", trigger: "change"},
          // maintManagerId: {required: true, type: "array", message: "请选择维保经理", trigger: "change"},
          // salesmanId: {required: true, type: "array", message: "请选择业务员", trigger: "change"},
          // areaManagerId: {required: true, type: "array", message: "请选择区域经理", trigger: "change"},
        },
      };
    },
    methods: {
      open(id) {
        this.project.id = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `projects/${this.project.id}`)
          .then(resp => {
            this.project = resp.data;
          });
      },
      onSelectCompany(row) {
        this.project.propertyCompanyId = row.id;
        this.project.propertyCompany = row.name;
      },
      onSelectMaintenanceManager(row) {
        this.project.maintenanceManagerId = row.id;
        this.project.maintenanceManager = row.name;
      },
      onSelectSalesman(row) {
        this.project.salesmanId = row.id;
        this.project.salesman = row.name;
      },
      onSelectAreaManager(row) {
        this.project.areaManagerId = row.id;
        this.project.areaManager = row.name;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            console.log(this.project);
            this.submitLoading = true;
            this.$http
              .save("basic", "projects", this.project)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
